import { CSSProperties } from 'react';

interface StatCardProps {
  value: number | string;
  label: string;
  hint?: string;
  accent?: string;
  style?: CSSProperties;
}

export default function StatCard({
  value,
  label,
  hint,
  accent,
  style,
}: StatCardProps) {
  return (
    <div
      className="acc-stat-card"
      style={{
        ...(accent
          ? {
              ['--acc-stat-accent' as string]: accent,
            }
          : {}),
        ...style,
      }}
    >
      <div className="acc-stat-card__label-row">
        <span className="acc-stat-card__accent" aria-hidden="true" />
        <div className="acc-stat-card__label">{label}</div>
      </div>
      <div className="acc-stat-card__value">{value}</div>
      {hint && <div className="acc-stat-card__hint">{hint}</div>}
    </div>
  );
}
